@let part = this.part();

@if (isLabelValueSplit) {
    <div class="part">
        @if (showLabel) {
            <div
                class="partLabelSplit ellipsis"
                [style.max-width.%]="100 - valueSize"
                [style.justifyContent]="getJustifyContent(part.field.labelFormatting)"
                [style.alignItems]="getAlignItems(part.field.labelFormatting)"
                [style.alignContent]="getAlignItems(part.field.labelFormatting)"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </div>
        }
        <div
            class="partValueSplit"
            [style.max-width.%]="valueSize"
            [style.justifyContent]="getJustifyContent(part.field.valueFormatting)"
            [style.alignItems]="getAlignItems(part.field.valueFormatting)"
            [style.alignContent]="getAlignItems(part.field.valueFormatting)"
            [style.color]="getFontColor(part.field.valueFormatting)"
            [style.fontSize]="getFontSize(part.field.valueFormatting)"
            [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
            [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
            [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
            <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
        </div>
    </div>
}

@if (isLabelValueJoin) {
    <div class="part">
        <div
            class="partJoin"
            [style.justifyContent]="getJustifyContent(part.field.valueFormatting)"
            [style.alignItems]="getAlignItems(part.field.valueFormatting)"
            [style.alignContent]="getAlignItems(part.field.valueFormatting)">
            <span
                class="partLabelJoin"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </span>
            &nbsp;
            <span
                class="partValueJoin"
                [style.color]="getFontColor(part.field.valueFormatting)"
                [style.fontSize]="getFontSize(part.field.valueFormatting)"
                [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
                [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
                <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
            </span>
        </div>
    </div>
}

@if (isLabelValueVertical) {
    <div
        class="part part--vertical"
        [style.justifyContent]="getJustifyContent(part.field.valueFormatting)"
        [style.alignItems]="getAlignItems(part.field.valueFormatting)"
        [style.alignContent]="getAlignItems(part.field.valueFormatting)">
        <div class="partVertical">
            <div
                class="partLabelVertical"
                [style.color]="getFontColor(part.field.labelFormatting)"
                [style.fontSize]="getFontSize(part.field.labelFormatting)"
                [style.fontWeight]="getFontWeight(part.field.labelFormatting)"
                [style.fontStyle]="getFontStyle(part.field.labelFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.labelFormatting)"
                [title]="part.field.label">
                {{ part.field.label }}{{ part.field.labelFormatting.showColon ? ":" : "" }}
            </div>
            <div
                class="partValueVertical"
                [style.color]="getFontColor(part.field.valueFormatting)"
                [style.fontSize]="getFontSize(part.field.valueFormatting)"
                [style.fontWeight]="getFontWeight(part.field.valueFormatting)"
                [style.fontStyle]="getFontStyle(part.field.valueFormatting)"
                [style.textDecoration]="getTextDecoration(part.field.valueFormatting)">
                <ng-container [ngTemplateOutlet]="valueFormatTpl"></ng-container>
            </div>
        </div>
    </div>
}

<ng-template #valueFormatTpl>
    @if (part.isNumber && part.valueNumber) {
        @if (part.isNumberIndicator) {
            <ng-container [ngTemplateOutlet]="numberIndicatorTpl"></ng-container>
        }
        @if (part.isNumberProgress) {
            <ng-container [ngTemplateOutlet]="numberProgressTpl"></ng-container>
        }
        @if (!part.isNumberIndicator && !part.isNumberProgress) {
            <ng-container [ngTemplateOutlet]="numberTpl"></ng-container>
        }
    }
    @if (part.isDate && part.valueString) {
        <span [title]="part.valueString | itvDateTimeWithRestrictions: part.field.restrictions">
            {{ part.valueString | itvDateTimeWithRestrictions: part.field.restrictions }}
        </span>
    }
    @if (part.isText) {
        <span [title]="part.valueString" [innerHTML]="part.valueString"></span>
    }
    @if (part.isTable || part.isWeather) {
        <ng-container [ngTemplateOutlet]="tableTpl"></ng-container>
    }
    @if (part.isAttachment) {
        <div class="part-list-scroll">
            <ng-container [ngTemplateOutlet]="attachmentTpl"></ng-container>
        </div>
    }
    @if (part.isRelation) {
        <div class="part-list-scroll">
            <ng-container [ngTemplateOutlet]="relationTpl"></ng-container>
        </div>
    }
    @if (part.isYesNo) {
        <ng-container [ngTemplateOutlet]="yesNoTpl"></ng-container>
    }
    @if (part.isState && part.valueState) {
        <ng-container [ngTemplateOutlet]="stateTpl"></ng-container>
    }
    @if (part.isLine) {
        <ng-container [ngTemplateOutlet]="lineTpl"></ng-container>
    }
</ng-template>

<ng-template #tableTpl>
    @if (part.valueTableRows?.length) {
        <div class="part-table-scroll">
            <table
                class="part-table-value"
                [attr.aria-label]="part.field.label"
                [attr.aria-busy]="!tableColumnsLoaded()">
                @if (tableColumns().length) {
                    <tr>
                        @for (column of tableColumns(); track column.id) {
                            <th>{{ column.label || column.name }}</th>
                        }
                    </tr>
                }
                @for (row of part.valueTableRows; track $index) {
                    <tr>
                        @if (!tableColumnsLoaded()) {
                            <td [attr.colspan]="row.length || 1">
                                <ngx-skeleton-loader
                                    class="cipo--width--full"
                                    [theme]="{ height: '16px', margin: 0, display: 'block', 'border-radius': '4px' }" />
                            </td>
                        } @else if (tableColumns().length) {
                            @for (column of tableColumns(); track column.id; let i = $index) {
                                <td>
                                    @switch (column.type) {
                                        @case (fieldTypeEnum.Number) {
                                            {{
                                                row[i]
                                                    | itvNumberWithFormattings
                                                        : column.formattings
                                                        : column.restrictions
                                                        : part.currency
                                            }}
                                        }
                                        @case (fieldTypeEnum.Date) {
                                            {{ row[i] | itvDateTimeWithRestrictions: column.restrictions }}
                                        }
                                        @default {
                                            {{ row[i] }}
                                        }
                                    }
                                </td>
                            }
                        } @else {
                            @for (value of row; track $index) {
                                <td>{{ value }}</td>
                            }
                        }
                    </tr>
                }
            </table>
        </div>
    }
</ng-template>

<ng-template #attachmentTpl>
    @for (name of part.valueAttachmentNames; track $index) {
        <span class="part-attachment-item" [title]="name">
            <mat-icon class="part-attachment-icon">{{ getAttachmentIcon(name) }}</mat-icon>
            {{ name }}
        </span>
    }
</ng-template>

<ng-template #relationTpl>
    @for (relation of part.valueRelations; track $index) {
        @if (relation.entityInstanceId && relation.moduleId) {
            <a
                class="part-relation-link"
                href="javascript:void(0)"
                [title]="relation.label"
                (click)="openRelation($event, relation)">
                {{ relation.label }}
            </a>
        } @else {
            <span class="part-relation-item" [title]="relation.label">{{ relation.label }}</span>
        }
    }
</ng-template>

<ng-template #numberTpl>
    <span
        [title]="
            part.valueNumber
                | itvNumberWithFormattings: part.field.formattings : part.field.restrictions : part.currency
        ">
        {{
            part.valueNumber
                | itvNumberWithFormattings: part.field.formattings : part.field.restrictions : part.currency
        }}
    </span>
</ng-template>

<ng-template #numberIndicatorTpl>
    <mat-icon class="indicator-icon">
        {{ part.isNumberIndicatorDown ? "arrow_drop_down" : "arrow_drop_up" }}
    </mat-icon>
    <ng-container *ngTemplateOutlet="numberTpl"></ng-container>
</ng-template>

<ng-template #numberProgressTpl>
    <itv-number-progress-bar
        [value]="numberProgressValue"
        [formattings]="part.field.formattings"
        [restrictions]="part.field.restrictions"
        [isDuration]="part.isNumberDurationProgress"></itv-number-progress-bar>
</ng-template>

<ng-template #yesNoTpl>
    {{ part.valueString ? part.valueString : part.valueBoolean ? "Yes" : "No" }}
</ng-template>

<ng-template #stateTpl>
    <cipo-state
        [customClass]="'stateBlock'"
        [name]="part.valueState.label"
        [bgColor]="part.valueState.bgColor"
        [textColor]="part.valueState.color"
        [fontWeight]="getFontWeight(part.field.valueFormatting)"
        [fontStyle]="getFontStyle(part.field.valueFormatting)"
        [textDecoration]="getTextDecoration(part.field.valueFormatting)"
        [fontSize]="getFontSize(part.field.valueFormatting)" />
</ng-template>

<ng-template #lineTpl>
    <hr class="lineBlock" [style.borderTopColor]="getFontColor(part.field.valueFormatting)" />
</ng-template>
